import React from 'react';
import { Button } from 'reactstrap';
import { withLocalize } from 'react-localize-redux';
import PropTypes from 'prop-types';


function LanguageButton(props) {
  const language = `cif-${props.language}`;
  return (
    <Button
      active={props.language === props.activeLanguage}
      style={{ margin: '0.25rem', padding: '0.25rem 0.5rem' }}
      onClick={props.onClick}
    >
      <i
        style={{
          width: '3rem',
          height: '2rem',
          verticalAlign: 'middle',
          margin: '0',
        }}
        className={language}
      />
    </Button>
  );
}

LanguageButton.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

const LanguageButtons = ({ languages, activeLanguage, setActiveLanguage }) => (
  languages.map((lang) => (
    <LanguageButton
      key={lang.code}
      activeLanguage={activeLanguage.code}
      language={lang.code}
      onClick={() => setActiveLanguage(lang.code)}
    />
  ))

);

export default withLocalize(LanguageButtons);
